const counters = {
    chatCounters: {
        aggregated: {
            activeChatsCounter: 0,
            assignedChatsCounter: 0,
            agentChatsCounter: 0,
            aiAgentChatsCounter: 0,
            unassignedChatsCounter: 0,
            waitingAnswerChatsCounter: 0,
        },
        webChat: {
            activeChatsCounter: 0,
            assignedChatsCounter: 0,
            agentChatsCounter: 0,
            aiAgentChatsCounter: 0,
            unassignedChatsCounter: 0,
            waitingAnswerChatsCounter: 0,
        },
        whatsapp: {
            activeChatsCounter: 0,
            assignedChatsCounter: 0,
            agentChatsCounter: 0,
            aiAgentChatsCounter: 0,
            unassignedChatsCounter: 0,
            waitingAnswerChatsCounter: 0,
        },
        facebook: {
            activeChatsCounter: 0,
            assignedChatsCounter: 0,
            agentChatsCounter: 0,
            aiAgentChatsCounter: 0,
            unassignedChatsCounter: 0,
            waitingAnswerChatsCounter: 0,
        },
        instagram: {
            activeChatsCounter: 0,
            assignedChatsCounter: 0,
            agentChatsCounter: 0,
            aiAgentChatsCounter: 0,
            unassignedChatsCounter: 0,
            waitingAnswerChatsCounter: 0,
        },
        aggregatedByUserId: {},
    },
    userChatsCounters: {
        assignedChatsToUserCounter: 0,
        waitingAnswerChatsAssignedToUserCounter: 0,
    },
};
export const AGGREGATED = "aggregated";
export const WEB_CHAT = "webChat";
export const INSTAGRAM = "instagram";
export const FACEBOOK = "facebook";
export const WHATSAPP = "whatsapp";
export const AGGREGATED_BY_USER_ID = "aggregatedByUserId";
export default counters;
